<template>
    <div class="flex flex-col gap-6">
        <h2 class="text-2xl md:text-4xl font-semibold">Genetic Test Results</h2>

        <div>
            <h3 class="text-base md:text-2xl font-semibold mb-3">Genetic test results<sup>1</sup></h3>

            <ul class="list-disc pl-4  font-light">
                <li>
                    DNA testing was performed using sequence analysis and copy number variation analysis of the <span class="italic text-lightblue">AGXT</span>,
                    <span class="italic">GRHPR</span>, and <span class="italic">HOGA1</span> genes
                </li>
                <li>
                    The patient was homozygous for <span class="italic text-lightblue">AGXT</span> c.680+1G>A, which is pathogenic and associated with a phenotype
                    of PH1
                </li>
                <li>Literature recommends to offer genetic counselling to patients with PH and their families<sup>2</sup></li>
            </ul>
        </div>

        

        <h2 class="text-2xl md:text-3xl font-semibold text-center">Algorithm for Diagnostic Evaluation of PH – Genetic Testing<sup>2–4</sup></h2>

        <img
            src="@/assets/img/graphics/eskd/genetic-testing-desktop.svg"
            alt="Genetic Testing"
            class="hidden sm:block"
        />
        <img src="@/assets/img/graphics/eskd/genetic-testing-mobile.svg" alt="Genetic Testing" class="sm:hidden" />

        <h3 class="text-base md:text-2xl font-semibold mb-3 p-6 bg-lightblue50 text-center">
            Genetic confirmation of PH1?<sup>1</sup> Yes
        </h3>
    </div>
</template>
